import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { ModalClose } from '../components/modal-close.tsx';


export default function ModalInfoWohnflaeche() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Wohnfläche</h1>
            <p id="modal-description">Bitte die Gesamtfläche derjenigen Räume im Haus angeben, die beheizt werden. Beheizte Wohnflächen sind i.d.R. Wohnzimmer, Badezimmer, Küchen, Schlafzimmer usw.. Nebenräume, in denen kein Heizkörper vorhanden ist, zählen nicht dazu, etwa das Treppenhaus, Flure oder Abstellräume.</p>
             <ModalClose label={"schließen"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

